export const  style = {
      
    minWidth: '300px',
    minHeight: '55px',
    border: '1px solid #31d0aa',
    padding: '16px',
    color: '#fff',
    fontWeight:"500",
    background: '#101010',
    zIndex:"99999"
    
}

export const iconTheme = {
    primary: '#000',
    secondary: '#fff',
}

export const  position= {
    position: "top-center"
}


export const  zindex= {
    zIndex: "99999"
}